<div
  class="submenu-trigger"
  #triggerEl
  role="menuitem"
  tabindex="-1"
  aria-haspopup="menu"
  [attr.aria-expanded]="isOpen"
  (mouseenter)="onTriggerEnter()"
  (mouseleave)="onTriggerLeave()"
  (keydown)="onTriggerKeydown($event)"
  (click)="$event.stopPropagation(); openFromKeyboard()">
  <div class="content-wrapper">
    <ng-content select=".submenu-icon"></ng-content>
    <span>{{ label() }}</span>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="chevron-icon" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
</div>
<ng-template #submenuTemplate>
  <div
    class="submenu-panel"
    role="menu"
    tabindex="-1"
    [attr.aria-label]="label()"
    (mouseenter)="onPanelEnter()"
    (mouseleave)="onPanelLeave()"
    (keydown)="onPanelKeydown($event)"
    (click)="onPanelClick()">
    <ng-content></ng-content>
  </div>
</ng-template>
